import React from 'react';
import { useTranslation } from 'react-i18next';
import { TeamMember } from '../types';
import './Team.css';

const Team: React.FC = () => {
  const { t } = useTranslation();
  
  const teamMembers: TeamMember[] = [
    {
      id: '1',
      name: t('about.team.members.drNeshadAlbani.name'),
      role: t('about.team.members.drNeshadAlbani.role'),
      bio: t('about.team.members.drNeshadAlbani.bio'),
      image: null
    },
    {
      id: '2',
      name: t('about.team.members.profArmandKrasniqi.name'),
      role: t('about.team.members.profArmandKrasniqi.role'),
      bio: t('about.team.members.profArmandKrasniqi.bio'),
      image: null
    },
    {
      id: '3',
      name: t('about.team.members.profBashkimNurboja.name'),
      role: t('about.team.members.profBashkimNurboja.role'),
      bio: t('about.team.members.profBashkimNurboja.bio'),
      image: null
    },
    {
      id: '4',
      name: t('about.team.members.mrGentianLluka.name'),
      role: t('about.team.members.mrGentianLluka.role'),
      bio: t('about.team.members.mrGentianLluka.bio'),
      image: null
    },
    {
      id: '5',
      name: t('about.team.members.drDardanAlbani.name'),
      role: t('about.team.members.drDardanAlbani.role'),
      bio: t('about.team.members.drDardanAlbani.bio'),
      image: null
    },
    {
      id: '6',
      name: t('about.team.members.mrsCelinaBegolli.name'),
      role: t('about.team.members.mrsCelinaBegolli.role'),
      bio: t('about.team.members.mrsCelinaBegolli.bio'),
      image: null
    },
    {
      id: '7',
      name: t('about.team.members.mrsFjollaLluka.name'),
      role: t('about.team.members.mrsFjollaLluka.role'),
      bio: t('about.team.members.mrsFjollaLluka.bio'),
      image: null
    },
    {
      id: '8',
      name: t('about.team.members.mrArberAlbani.name'),
      role: t('about.team.members.mrArberAlbani.role'),
      bio: t('about.team.members.mrArberAlbani.bio'),
      image: null
    },
    {
      id: '9',
      name: t('about.team.members.mrIlirAlbani.name'),
      role: t('about.team.members.mrIlirAlbani.role'),
      bio: t('about.team.members.mrIlirAlbani.bio'),
      image: null
    }
  ];

  return (
    <div className="team-page">
      {/* Hero Section */}
      <section className="team-hero section">
        <div className="container">
          <div className="team-hero-content text-center">
            <h1>{t('about.team.title')}</h1>
            <p>{t('about.team.description')}</p>
          </div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className="team-members section">
        <div className="container">
          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-card">
                {member.image && (
                  <div className="team-image">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      onError={(e) => {
                        e.currentTarget.src = '/images/placeholder-avatar.png';
                      }}
                    />
                  </div>
                )}
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
